import { render, staticRenderFns } from "./Chatcontrols.vue?vue&type=template&id=738eef1a&scoped=true&"
import script from "./Chatcontrols.vue?vue&type=script&lang=js&"
export * from "./Chatcontrols.vue?vue&type=script&lang=js&"
import style0 from "./Chatcontrols.vue?vue&type=style&index=0&id=738eef1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738eef1a",
  null
  
)

export default component.exports